const features = [
    {
        title: "Number of products",
        lite: "Unlimited",
        pro: "Unlimited"
    },
    {
        title: "Number of documents",
        lite: "Unlimited",
        pro: "Unlimited"
    },
    {
        title: "Number of customers",
        lite: "Unlimited",
        pro: "Unlimited"
    },
    {
        title: "Number of users",
        lite: "Unlimited",
        pro: "Unlimited"
    },
    {
        title: "Multiple computers using single database",
        lite: false,
        pro: true
    },
    {
        title: "Printed or electronic receipts",
        lite: true,
        pro: true
    },
    {
        title: "Inventory management",
        lite: true,
        pro: true
    },
    {
        title: "Discounts",
        lite: true,
        pro: true
    },
    {
        title: "Security",
        lite: true,
        pro: true
    },
    {
        title: "Loyalty cards",
        lite: true,
        pro: true
    },
    {
        title: "Credit payments",
        lite: true,
        pro: true
    },
    {
        title: "Standard and Touch screen layout",
        lite: true,
        pro: true
    },
    {
        title: "Custom payment types",
        lite: true,
        pro: true
    },
    {
        title: "Promotions & Happy hour",
        lite: true,
        pro: true
    },
    {
        title: "Tax exempt sale",
        lite: true,
        pro: true
    },
    {
        title: "Reporting ",
        lite: true,
        pro: true
    },
    {
        title: "Support barcodes and weight barcodes",
        lite: true,
        pro: true
    },
    {
        title: "Custom receipts",
        lite: true,
        pro: true
    },
    {
        title: "Notes",
        lite: true,
        pro: true
    },
    {
        title: "Stock control",
        lite: true,
        pro: true
    },
    {
        title: "Priority support",
        lite: false,
        pro: true
    },
]

const plugins = [
    {
        name: 'Expiration date',
        description: 'Track products\' expiration date and print reports of expiring products in a specified period.',
        slug: 'expiration-date'
    },
    {
        name: 'Dual currency',
        description: 'Prints receipt total in a second currency of your choice.',
        slug: 'dual-currency'
    },
    {
        name: 'Price lists',
        price: 5,
        description: 'Assign different price list to cash registers or customers and operate as a retail or wholesale.',
        monthlySubscriptionAvailable: true,
        slug: 'price-lists'
    },
    {
        name: 'E-invoice in KSA',
        country: "Saudi Arabia",
        description: 'Implements Saudi Arabia electronic invoice requirements and prints required QR code on simplified invoice.',
        slug: 'e-invoice-ksa'
    },
    {
        name: 'Fatoora',
        country: "Saudi Arabia",
        price: 8,
        description: 'Integrate Aronium with Fatoora to ensure compliance with ZATCA Phase 2 electronic invoicing requirements.',
        monthlySubscriptionAvailable: true,
        slug: 'fatoora'
    },
    {
        name: 'Vanuatu VSMS',
        country: "Vanuatu",
        price: 10,
        description: 'Connect Aronium to Vanuatu\'s Sales Monitoring System and issue compliant electronic invoices directly from your POS.',
        monthlySubscriptionAvailable: true,
        slug: 'vsms'
    },
    {
        name: 'Fiji VMS',
        country: "Fiji",
        price: 10,
        description: 'Connect Aronium to Fiji\'s VAT Monitoring System and issue compliant fiscal invoices directly from your POS.',
        monthlySubscriptionAvailable: true,
        slug: 'fiji-vms'
    },
    {
        name: 'My logo',
        price: 1,
        description: 'Add your company logo to a login screen.',
        monthlySubscriptionAvailable: false,
        slug: 'my-logo'
    },
    {
        name: 'Print stations',
        price: 5,
        description: 'Print kitchen and bar orders to different printers.',
        monthlySubscriptionAvailable: true,
        slug: 'print-stations'
    },
    {
        name: 'Notes',
        description: 'Add notes after sale is closed and print them on receipt or invoice.',
        slug: 'notes'
    },
    {
        name: 'Named order',
        description: 'Give descriptive name to open orders and track in-store customers easily.',
        slug: 'named-order'
    },
    {
        name: 'Stock control',
        description: 'Get more control over your stock quantities with low stock warnings.',
        slug: 'stock-control'
    },
    {
        name: 'Email reporting',
        price: 3,
        description: 'Schedule daily sales report to be sent automatically and delivered to your email.',
        monthlySubscriptionAvailable: false,
        slug: 'email-reporting'
    },
    {
        name: 'MRP',
        description: 'Specify and print product\'s maximum retail price (MRP) in receipt and invoice.',
        slug: 'mrp'
    },
    {
        name: 'Takeaway',
        description: 'Add a Takeaway or Dine-in choice to each order and highlight large order numbers on Takeaway receipts.',
        slug: 'takeaway'
    },
]

export function getPlugins() {
    return plugins;
}

export function getFeatures() {
    return features;
}

export async function getCountry() {
    const cached = sessionStorage.getItem('user_country');
    if (cached) return cached; 

    try {
        const response = await fetch('https://api.country.is/'); 
        const data = await response.json();
        sessionStorage.setItem('user_country', data.country); 
        return data.country;
    } catch (error) {
        console.error("Error fetching country:", error); 
        sessionStorage.setItem('user_country', ''); 
        return null; 
    }
}


export const BASE_URL = "https://download.aronium.com";
export const COOKIE_KEY = 'cookie_consent'; 
